export interface LoanSensitivityAnalysis {
  type: 'loan_sensitivity_analyses';
  id: string;
  attributes: LoanSensitivityAnalysisAttributes;
  relationships?: {
    user?: {
      type: string;
      id: string;
      attributes?: {
        email?: string;
      };
    };
  };
}

export interface LoanSensitivityAnalysisAttributes {
  company_ref_uuid: string;
  user_id: string;
  user_email?: string;
  currency_code: string;
  currency_exchange_rate: string;
  measured_by: string;
  name: string;
  description: string;
  financial_statement_category: string;
  loan_id: string;
  assets_ids: string[];
  financial_statements_ids: string[];
  total_area: number;
  region: string;
  note_date: number;
  maturity_date: number;
  payment_type: string;
  net_rental_income: number;
  other_income: number;
  base_loan_amount: number;
  increment_loan_amount: number;
  amortization_term: number;
  interest_rate_spread: number;
  interest_type: string;
  interest_only_end_date: number;
  interest_rate_index: string;
  base_vacancy?: number;
  custom_vacancy?: number;
  increment_vacancy: number;
  debt_services: number;
  base_total_operating_expenses?: number;
  effective_gross_income?: number | null;
  custom_total_operating_expenses?: number;
  increment_total_operating_expenses: number;
  base_interest_rate?: number;
  custom_interest_rate?: number;
  increment_interest_rate: number;
  base_market_value?: number;
  custom_market_value?: number;
  increment_market_value: number;
  base_cap_rate?: number;
  custom_cap_rate?: number;
  increment_cap_rate: number;
  base_average_rental_rate?: number;
  custom_average_rental_rate?: number;
  increment_average_rental_rate: number;
  base_net_operating_income?: number;
  custom_net_operating_income?: number;
  increment_net_operating_income: number;
  break_dscr: number;
  break_ltv: number;
  created_at: number;
}

export const loanSensitivityAnalysisFields = [
  'company_ref_uuid',
  'user_id',
  'user_email',
  'currency_code',
  'currency_exchange_rate',
  'measured_by',
  'name',
  'description',
  'financial_statement_category',
  'loan_id',
  'assets_ids',
  'financial_statements_ids',
  'total_area',
  'region',
  'note_date',
  'maturity_date',
  'payment_type',
  'net_rental_income',
  'other_income',
  'base_loan_amount',
  'increment_loan_amount',
  'amortization_term',
  'interest_rate_spread',
  'interest_type',
  'interest_only_end_date',
  'interest_rate_index',
  'base_vacancy',
  'custom_vacancy',
  'increment_vacancy',
  'debt_services',
  'base_total_operating_expenses',
  'custom_total_operating_expenses',
  'increment_total_operating_expenses',
  'effective_gross_income',
  'base_interest_rate',
  'custom_interest_rate',
  'increment_interest_rate',
  'base_market_value',
  'custom_market_value',
  'increment_market_value',
  'base_cap_rate',
  'custom_cap_rate',
  'increment_cap_rate',
  'base_average_rental_rate',
  'custom_average_rental_rate',
  'increment_average_rental_rate',
  'base_net_operating_income',
  'custom_net_operating_income',
  'increment_net_operating_income',
  'break_dscr',
  'break_ltv',
  'created_at',
];
